import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';
import { FieldValues } from 'react-hook-form';

interface Option {
  value: string;
  label: string;
}

type BaseSelectProps = React.ComponentPropsWithoutRef<typeof Select>;

// interface SelectProps {
//   name: string;
//   label?: string | null;
//   placeholder?: string | null;
//   options: Option[] | undefined;
//   className?: string;
//   selectClass?: string;
//   labelClass?: string;
//   control: any;
//   description?: string;
//   required?: boolean;
//   disabled?: boolean;
//   notRequired?: boolean;
// }

interface SelectProps<T extends FieldValues>
  extends Omit<BaseSelectProps, 'value' | 'onValueChange'> {
  name: string;
  label?: string | null;
  placeholder?: string | null;
  options: Option[] | undefined;
  className?: string;
  selectClass?: string;
  labelClass?: string;
  control: any;
  description?: string;
  required?: boolean;
  disabled?: boolean;
  notRequired?: boolean;
  onChange?: (value: string) => void;
}

export default function SelectControl<T extends FieldValues>({
  name,
  label,
  placeholder,
  options,
  control,
  description,
  className,
  selectClass,
  labelClass,
  required,
  disabled,
  notRequired,
  onChange,
  ...props
}: SelectProps<T>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={cn(className)}>
          {label && (
            <FormLabel className={labelClass}>
              {label} {required && <span className={cn('text-red')}>*</span>}
            </FormLabel>
          )}
          <Select
            {...props}
            onValueChange={(value) => {
              field.onChange(value);
              if (onChange) {
                onChange(value);
              }
            }}
            value={field.value}
            disabled={disabled}
            onOpenChange={(open) => {
              if (disabled && open) {
                return false;
              }
            }}
          >
            <FormControl>
              <SelectTrigger
                className={cn(
                  selectClass,
                  disabled && 'opacity-50 cursor-not-allowed ',
                  'bg-white',
                )}
              >
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectGroup>
                {options?.map((item) => {
                  if (!item?.value) return null;
                  return (
                    <SelectItem value={item.value} key={item.value}>
                      {item.label}
                    </SelectItem>
                  );
                })}
              </SelectGroup>
            </SelectContent>
          </Select>
          {description && <FormDescription>{description}</FormDescription>}
          {!notRequired && (
            <div className={'h-4 !mt-1'}>
              <FormMessage />
            </div>
          )}
        </FormItem>
      )}
    />
  );
}
